import { BarChart, Box, Button } from "@amzn/awsui-components-react";
import { Funding } from "../../../calcBusterTypes";
import { USDollar } from "../../../util";

const AnnualRunRateBarChart = (funding: Funding) => {
  const estimatedArr = funding.annualRunRate;
  const mobilizeAndMigrateFunding = funding.map.mobilizeAndMigrate;
  const eligibleArr = mobilizeAndMigrateFunding.eligibleAnnualRunRate;
  const modernizationARR =
    mobilizeAndMigrateFunding.cash?.modernization?.eligibleAnnualRunRate ?? 0;

  const sapEligibleARR =
    mobilizeAndMigrateFunding.credits?.sapAndOracle?.eligibleAnnualRunRate ?? 0;

  const dbAndAnalyticsEligibleARR =
    mobilizeAndMigrateFunding.credits?.dbAndAnalytics?.eligibleAnnualRunRate ??
    0;

  return (
    <BarChart
      series={[
        {
          title: "Qualification ARR",
          type: "bar",
          data: [{ x: "Annual Run Rate", y: estimatedArr }],
          valueFormatter: function numberFormatter(e) {
            return USDollar.format(e);
          },
        },
        {
          title: "MAP Eligible ARR",
          type: "bar",
          data: [{ x: "Annual Run Rate", y: eligibleArr }],
          valueFormatter: function numberFormatter(e) {
            return USDollar.format(e);
          },
        },
        {
          title: "Modernization ARR",
          type: "bar",
          data: [{ x: "Annual Run Rate", y: modernizationARR }],
          valueFormatter: function numberFormatter(e) {
            return USDollar.format(e);
          },
        },
        {
          title: "SAP and Oracle Eligible ARR",
          type: "bar",
          data: [{ x: "Annual Run Rate", y: sapEligibleARR }],
          valueFormatter: function numberFormatter(e) {
            return USDollar.format(e);
          },
        },
        {
          title: "DB and Analytics Eligible ARR",
          type: "bar",
          data: [{ x: "Annual Run Rate", y: dbAndAnalyticsEligibleARR }],
          valueFormatter: function numberFormatter(e) {
            return USDollar.format(e);
          },
        },
      ]}
      xDomain={["Annual Run Rate"]}
      ariaLabel="Multiple data series line chart"
      height={200}
      xTitle="Annual Run Rate"
      yTitle="USD"
      hideFilter
      empty={
        <Box textAlign="center" color="inherit">
          <b>No data available</b>
          <Box variant="p" color="inherit">
            There is no data available
          </Box>
        </Box>
      }
      noMatch={
        <Box textAlign="center" color="inherit">
          <b>No matching data</b>
          <Box variant="p" color="inherit">
            There is no matching data to display
          </Box>
          <Button>Clear filter</Button>
        </Box>
      }
    />
  );
};

export default AnnualRunRateBarChart;
